// @ts-nocheck
import React from 'react';
import { motion } from 'framer-motion';
import aboutImage from '../assets/Group 4373.png'; // You'll need to replace this with your actual image path

const fadeInUp = {
  hidden: { opacity: 0, y: 20 },
  visible: { 
    opacity: 1, 
    y: 0,
    transition: { duration: 0.6 }
  }
};

const floatAnimation = {
  y: [0, -20, 0],
  rotate: [0, 5, 0],
  scale: [1, 1.05, 1],
  transition: {
    duration: 4,
    repeat: Infinity,
    ease: "easeInOut"
  }
};

const glowAnimation = {
  opacity: [0.5, 0.8, 0.5],
  scale: [1, 1.2, 1],
  transition: {
    duration: 4,
    repeat: Infinity,
    ease: "easeInOut"
  }
};

const AboutSection = () => {
  // Function to scroll to contact section in the footer
  const scrollToContact = () => {
    const footerSection = document.getElementById('footer-section');
    if (footerSection) {
      footerSection.scrollIntoView({ behavior: 'smooth' });
    }
  };
  
  return (
    <section id="about-us" className="section bg-black relative overflow-hidden">
      <div className="container">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Content */}
          <motion.div
            initial="hidden" 
            whileInView="visible"
            viewport={{ once: true, margin: "-100px" }}
            variants={{
              hidden: { opacity: 0 },
              visible: {
                opacity: 1,
                transition: {
                  staggerChildren: 0.2
                }
              }
            }}
          >
            <motion.h2 
              variants={fadeInUp}
              className="text-gray-500 text-xl font-semibold uppercase tracking-wider mb-2"
            >
              About Us
            </motion.h2>
            <motion.h2 
              variants={fadeInUp}
              className="text-white text-4xl font-bold mb-6"
            >
              Who Are We
            </motion.h2>
            
            <motion.p 
              variants={fadeInUp}
              className="text-lg text-text-secondary mb-6"
            >
              Link Bridge Consulting (LBC) is a startup consulting and advisory studio. We specialize in supporting traditional and Web3 startups to prepare for success.
            </motion.p>
            
            <motion.p 
              variants={fadeInUp}
              className="text-lg text-text-secondary mb-8"
            >
              Our team of seasoned professionals combines unparalleled local knowledge with a global perspective. We offer a comprehensive suite of services designed to propel your business forward, wherever you operate.
            </motion.p>
            
            <motion.div variants={fadeInUp}>
              <button 
                className="btn bg-secondary text-white hover:bg-secondary-hover"
                onClick={scrollToContact}
              >
                Start Project
              </button>
            </motion.div>
          </motion.div>
          
          {/* Image Element */}
          <motion.div
            initial={{ opacity: 0, scale: 0.8, rotate: -5 }}
            whileInView={{ opacity: 1, scale: 1, rotate: 0 }}
            transition={{ duration: 0.8 }}
            viewport={{ once: true, margin: "-100px" }}
            className="relative hidden lg:flex justify-center"
          >
            <div className="relative w-[400px] h-[400px]">
              <motion.img 
                src={aboutImage}
                alt="About Link Bridge Consulting"
                className="w-full h-full object-contain"
                animate={floatAnimation}
              />
              {/* Background glow */}
              <motion.div 
                className="absolute inset-0 -z-10 bg-gradient-to-br from-primary/10 to-transparent rounded-full blur-3xl"
                animate={glowAnimation}
              ></motion.div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection; 